// tslint:disable
/**
 * Firmabil lekeplass API
 * A description of the API
 *
 * OpenAPI spec version: v0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AdminPlayground,
    AdminPlaygroundFromJSON,
    AdminPlaygroundToJSON,
} from './';

/**
 * AdminPlaygroundNearbyList media type (default view)
 * @export
 * @interface AdminPlaygroundNearbyList
 */
export interface AdminPlaygroundNearbyList {
    /**
     * 
     * @type {number}
     * @memberof AdminPlaygroundNearbyList
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlaygroundNearbyList
     */
    lon: number;
    /**
     * 
     * @type {Array<AdminPlayground>}
     * @memberof AdminPlaygroundNearbyList
     */
    playgrounds?: Array<AdminPlayground>;
    /**
     * 
     * @type {number}
     * @memberof AdminPlaygroundNearbyList
     */
    radius: number;
}

export function AdminPlaygroundNearbyListFromJSON(json: any): AdminPlaygroundNearbyList {
    return {
        'lat': json['lat'],
        'lon': json['lon'],
        'playgrounds': !exists(json, 'playgrounds') ? undefined : (json['playgrounds'] as Array<any>).map(AdminPlaygroundFromJSON),
        'radius': json['radius'],
    };
}

export function AdminPlaygroundNearbyListToJSON(value?: AdminPlaygroundNearbyList): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'lat': value.lat,
        'lon': value.lon,
        'playgrounds': value.playgrounds === undefined ? undefined : (value.playgrounds as Array<any>).map(AdminPlaygroundToJSON),
        'radius': value.radius,
    };
}


